import * as React from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

const ClearableInput = React.forwardRef(
  ({ className, value, onChange, onClear, type = "text", ...props }, ref) => {
    const hasValue = value !== undefined && value !== null && value !== "";

    const handleClear = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (onClear) {
        onClear();
      } else if (onChange) {
        // Simulate a change event with empty value
        onChange({ target: { value: "" } });
      }
    };

    return (
      <div className="relative w-full">
        <input
          type={type}
          className={cn(
            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            hasValue && "pr-8",
            className
          )}
          value={value}
          onChange={onChange}
          ref={ref}
          {...props}
        />
        {hasValue && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 rounded-full text-muted-foreground/50 hover:text-muted-foreground transition-colors"
            tabIndex={-1}
            aria-label="Clear"
            data-testid={props["data-testid"] ? `${props["data-testid"]}-clear` : "input-clear"}
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    );
  }
);

ClearableInput.displayName = "ClearableInput";

export { ClearableInput };
